import { configureStore } from "@reduxjs/toolkit";
import implementerSlice from "../features/implementers/ImplemetnersSlice";
import uiSlice from "../features/ui/uiSlice";
import authSlice from "../features/auth/newAuth";

export const store = configureStore({
    reducer: {
        implementers: implementerSlice,
        ui: uiSlice,
        auth: authSlice,
    },
});
